import { render } from "./Fader.vue?vue&type=template&id=6b2a15c6&scoped=true"
import script from "./Fader.vue?vue&type=script&lang=js"
export * from "./Fader.vue?vue&type=script&lang=js"

import "./Fader.vue?vue&type=style&index=0&id=6b2a15c6&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2a15c6"]])

export default __exports__